<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
export default {

  //   methods: {
  //   async getContent() {
  //     // Query the API and assign the response to "response"
  //     const response = await this.$prismic.client.query(
  //       this.$prismic.Predicates.at("document.type", "project")
  //     );
  //     // const response = await this.$prismic.client.query(
  //     //   this.$prismic.Predicates.at("document.type", "project"),
  //     //   { orderings: "[my.work.date_creation desc]" }
  //     // );
  //     console.log(response.results);
  //     response.results.forEach((el) => {
  //       // console.log(el)
  //       this.prj.push(el);
  //     });
  //     this.$store.commit("pushPrj", this.prj);
  //     // console.log(this.worksa);
  //   },
  // },
  // created() {
  //   // Call the API query method
  //   this.getContent();
  // },
}
</script>

<style lang="scss">
@font-face {
  font-family: "Newake";
  src: url("./assets/Fonts/NewakeDemo.ttf") format("ttf"),
    url("./assets/Fonts/NewakeDemo.woff") format("woff"),
    url("./assets/Fonts/NewakeDemo.woff2") format("woff2");
  font-display: fallback;
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SangBleuEmpire";
  src: url("./assets/Fonts/SangBleuEmpire-Regular.ttf") format("ttf"),
    url("./assets/Fonts/SangBleuEmpire-Regular.woff") format("woff"),
    url("./assets/Fonts/SangBleuEmpire-Regular.woff2") format("woff2");
  font-display: fallback;
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Lausanne";
  src: url("./assets/Fonts/Lausanne-300.woff2") format("woff2"),
    url("./assets/Fonts/Lausanne-300.woff") format("woff"),
    url("./assets/Fonts/Lausanne-300.ttf") format("ttf");
  font-display: fallback;
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Lausanne";
  src: url("./assets/Fonts/Lausanne-500.woff2") format("woff2"),
    url("./assets/Fonts/Lausanne-500.woff") format("woff"),
    url("./assets/Fonts/Lausanne-500.ttf") format("ttf");
  font-display: fallback;
  font-weight: bold;
  font-style: normal;
}
#app{
  -webkit-font-smoothing: antialiased;
}
</style>
